export default __webpack_public_path__ + "src/assets/icn-view-only.134e473a8443ea0e042509c758ba9b69.svg";